module.exports = __webpack_public_path__ + "images/emoji/parking.eb70c4cf6f23f008f269.png";